"use client";
import { ArticlePage } from "@/gql/graphql";
import { InformationMediaMicroCard } from "@nrldigitaltechnology/ui-community";
import { Card, NewsCard } from "@nrldigitaltechnology/ui-community/dist/components/InformationMediaMicroCard/types";
import dayjs from "dayjs";

type ArticleClientCmsProps = {
    data: ArticlePage[],
    title: string
};

export const ArticleClientCms = ({ data  , title}: ArticleClientCmsProps) => {

    const cardsMapping = () => {

        const formattedArticles = [] as NewsCard[];

        data?.map((cmsCard, index) => {
            formattedArticles.push({
                id: index,
                cardCtaUrl: `${cmsCard?._metadata?.url?.default}` || "",
                type: "news",
                image: cmsCard?.heroImage?.url?.default || "",
                category: (cmsCard && (cmsCard as any)?.body?.length > 0) ? (cmsCard as any)?.body[0]?.name : "",
                title: cmsCard?.summary || "",
                date : dayjs(cmsCard?._metadata?.published).format("MMMM D, YYYY"),
                onClickCard: (card) => {
                    if (card?.cardCtaUrl) {
                      window.open(card.cardCtaUrl, "_blank", "noopener,noreferrer");
                    }
                  }
            });
        });

        return formattedArticles;
    };

    return (
        <div className="w-full">
            <InformationMediaMicroCard title={title} cards={cardsMapping()} />
        </div>
    );
};


